exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-pinball-js": () => import("./../../../src/pages/pinball.js" /* webpackChunkName: "component---src-pages-pinball-js" */)
}

